import { createSlice } from "@reduxjs/toolkit";

export const getSoundEmissionLrMaxLimit = (apiLrMax) => {
  const value = Number(apiLrMax);
  return Math.max((Number.isFinite(value) ? value : 0) + 200, 300);
};

const initialState = {
  isVisible: false,
  selectedPoint: null,
  infoBoxShow: false,
  valueRange: [null, null],
  lrMax: null,
  apiLrMax: null,
  executions: [],
  executionsStatus: "idle",
  dataStatus: "idle",
  error: null,
  selectedBatchId: null,
  candidates: [],
  receivers: [],
  receiverLinksVisible: false,
};

const soundEmissionSlice = createSlice({
  name: "soundEmission",
  initialState,
  reducers: {
    toggleSoundEmission: (state) => {
      state.isVisible = !state.isVisible;
      if (!state.isVisible) state.infoBoxShow = false;
    },
    hideSoundEmission: (state) => {
      state.isVisible = false;
      state.infoBoxShow = false;
    },
    selectSoundEmissionPoint: (state, action) => {
      state.selectedPoint = action.payload;
      state.infoBoxShow = true;
    },
    hideSoundEmissionInfoBox: (state) => {
      state.infoBoxShow = false;
    },
    setSoundEmissionValueRange: (state, action) => {
      state.valueRange = action.payload;
    },
    setSoundEmissionApiLrMax: (state, action) => {
      const apiLrMax = Number(action.payload);
      if (!Number.isFinite(apiLrMax)) return;

      state.apiLrMax = apiLrMax;
      state.lrMax = apiLrMax;
    },
    setSoundEmissionReceiverLinksVisible: (state, action) => {
      state.receiverLinksVisible = !!action.payload;
    },
    setSoundEmissionLrMax: (state, action) => {
      const requestedLrMax = Number(action.payload);
      if (
        !Number.isFinite(requestedLrMax) ||
        !Number.isFinite(state.apiLrMax) ||
        !Number.isFinite(state.lrMax)
      )
        return;

      const nextLrMax = Math.min(
        getSoundEmissionLrMaxLimit(state.apiLrMax),
        Math.max(0, requestedLrMax),
      );
      const delta = nextLrMax - state.lrMax;
      state.lrMax = nextLrMax;
      if (state.selectedPoint) {
        state.selectedPoint.lr_max = nextLrMax;
        state.selectedPoint.max_allowable_lw += delta;
      }
    },
    loadSoundEmissionExecutions: (state) => {
      state.executionsStatus = "loading";
      state.executions = [];
      state.error = null;
    },
    setSoundEmissionExecutions: (state, action) => {
      state.executionsStatus = "succeeded";
      state.executions = action.payload;
    },
    failSoundEmissionExecutions: (state, action) => {
      state.executionsStatus = "failed";
      state.error = action.payload;
    },
    loadSoundEmissionExecutionData: (state, action) => {
      state.selectedBatchId = action.payload;
      state.dataStatus = "loading";
      state.error = null;
      state.isVisible = false;
      state.infoBoxShow = false;
      state.selectedPoint = null;
      state.candidates = [];
      state.receivers = [];
      state.lrMax = null;
      state.apiLrMax = null;
    },
    setSoundEmissionExecutionData: (state, action) => {
      state.dataStatus = "succeeded";
      state.selectedBatchId = action.payload.batchId;
      state.candidates = action.payload.candidates;
      state.receivers = action.payload.receivers;
      state.isVisible = true;
    },
    failSoundEmissionExecutionData: (state, action) => {
      state.dataStatus = "failed";
      state.error = action.payload;
      state.selectedBatchId = null;
    },
    resetSoundEmission: () => initialState,
  },
});

export const {
  toggleSoundEmission,
  hideSoundEmission,
  selectSoundEmissionPoint,
  hideSoundEmissionInfoBox,
  setSoundEmissionValueRange,
  setSoundEmissionApiLrMax,
  setSoundEmissionReceiverLinksVisible,
  setSoundEmissionLrMax,
  loadSoundEmissionExecutions,
  setSoundEmissionExecutions,
  failSoundEmissionExecutions,
  loadSoundEmissionExecutionData,
  setSoundEmissionExecutionData,
  failSoundEmissionExecutionData,
  resetSoundEmission,
} = soundEmissionSlice.actions;

export default soundEmissionSlice.reducer;
